import { render, staticRenderFns } from "./SectionCount.vue?vue&type=template&id=475fd014&scoped=true"
import script from "./SectionCount.vue?vue&type=script&lang=ts"
export * from "./SectionCount.vue?vue&type=script&lang=ts"
import style0 from "./SectionCount.vue?vue&type=style&index=0&id=475fd014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fd014",
  null
  
)

export default component.exports